<div class="page-container">
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">pie_chart</mat-icon>
      <div>
        <div class="page-title">Distributions</div>
        <div class="page-description">Manage tax distribution periods, amounts, and statuses for Tourist Development Tax collections.</div>
      </div>
    </div>
    <button mat-flat-button color="primary" class="add-button" (click)="addDistribution()">
      <mat-icon>add</mat-icon>
      ADD DISTRIBUTION
    </button>
  </div>

  <div class="mat-elevation-z2 table-card">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Distributions">

      <ng-container matColumnDef="distributionPeriod">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Distribution Period</th>
        <td mat-cell *matCellDef="let row">{{ row.distributionPeriod }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let row">{{ row.amount | currency }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="'status-' + row.status.toLowerCase()">{{ row.status }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="dateCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
        <td mat-cell *matCellDef="let row">{{ row.dateCreated | date }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="text-align: right; background-color: #E3E3E3;">Actions</th>
        <td mat-cell *matCellDef="let row" style="text-align: right;">
          <button mat-icon-button (click)="editDistribution(row); $event.stopPropagation()" aria-label="Edit distribution">
            <mat-icon class="action-icon edit-icon">edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteDistribution(row); $event.stopPropagation()" aria-label="Delete distribution">
            <mat-icon class="action-icon delete-icon">delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No distributions found.</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page"></mat-paginator>
  </div>
</div>
